import {EnvironmentProviders, makeEnvironmentProviders} from '@angular/core';
import {TABLE_SHOW_ACTIONS_HEADER_TEXT} from '@aviary/injection-tokens/app-provided.tokens';

export function provideAviaryTableColumnSettings(showActionsHeaderText: boolean): EnvironmentProviders {
  return makeEnvironmentProviders([
    {provide: TABLE_SHOW_ACTIONS_HEADER_TEXT, useValue: showActionsHeaderText}
  ]);
}
